import React from 'react';
import swal from 'sweetalert';
import { GridCell } from '@progress/kendo-react-grid';
import { Component } from 'react';

class ToggleStatus extends Component {
	constructor(props) {
		super(props);
		this.state = {
			batchInEdit: this.props.dataItem || null,
			batchStatus: this.props.dataItem.BatchJobId ? this.props.dataItem.BatchStatus.name : null,
			batchStatuses: this.props.batchStatuses
		};
	}

	completeToggle = () => {
		let newStatus = this.state.batchStatus == "Open" ? "Closed" : "Open";
		this.props.dataItem.BatchStatus = this.props.batchStatuses.filter((item) => {
			if (item.name === newStatus) {
				return item;
			}
		})[0];

		this.props.toggleStatus(this.props.dataItem);
	}

	render() {
		return (
			<div>
				{this.state.batchInEdit.BatchJobId ?
					<button
						className="admin-k-button "
						onClick={(event) => {
							event.preventDefault();
							swal({
								text: this.state.batchStatus == "Open" ? `Warning: Are you sure you want to close this batch?` :
									this.state.batchStatus == "Closed" ? `Warning: Are you sure you want to re-open this batch?` :
										`Warning: Are you sure you want to re-open this batch? It has already been processed. Closing this batch again will cause it to be re-processed with any corrections.`
								,
								icon: 'warning',
								buttons: {
									cancel: 'NO',
									confirm: 'YES'
								},
								dangerMode: true
							}).then((value) => (value ? this.completeToggle() : null));
						}}
					>
						{this.state.batchStatus == "Open" ? "CLOSE BATCH" : "RE-OPEN"}
					</button>	
					:""}
			</div>
		);
	};
}

export default ToggleStatus;